function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
class SectionId {
  static #separator = '__';
  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }
  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }
  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}
class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));
    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;
    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });
    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';
    postProcessCallbacks?.forEach((callback) => callback(newNode));
    setTimeout(() => oldNode.remove(), 500);
  }
  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }
  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });
  if (summary.closest('header-layer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };
  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  elementToFocus.focus();
  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}
// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;
  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });
  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });
  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
      if (mouseClick) return;
      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }
  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }
  onInputChange(event) {
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      } 
    } else {
      this.input.stepDown();
    }
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}
customElements.define('quantity-input', QuantityInput);
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}
/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};
Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};
Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};
Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};
  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);
  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = '';
    }
  },
  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },
  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};
class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }
  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }
  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }
  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    function addTrapFocus() {
      if(summaryElement.nextElementSibling, detailsElement.querySelector('button')) trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }
    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      if (window.matchMedia('(max-width: 992px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        const nextEl = summaryElement.nextElementSibling;
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        if (!reducedMotion || reducedMotion.matches) {
          addTrapFocus();
        } else if (nextEl) {
          nextEl.addEventListener('transitionend', addTrapFocus);
        }
      }, 100);
    }
  }
  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }
  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }
  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    if (!detailsElement) return;
    if (event.currentTarget.hasAttribute('data-drawer-close') && detailsElement === this.mainDetailsToggle) {
      this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
      return;
    }
    this.closeSubmenu(detailsElement);
  }
  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }
  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
}
document.querySelectorAll('.mobile-facets__close').forEach((closeButton) => {
  closeButton.addEventListener('click', (event) => {
    const detailsElement = closeButton.closest('details');
    if (detailsElement) {
      detailsElement.classList.remove('menu-opening');
      closeButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden-mobile');
      const drawer = detailsElement.closest('menu-drawer');
      if (drawer && drawer.closeAnimation) {
        drawer.closeAnimation(detailsElement);
      } else {
        detailsElement.removeAttribute('open');
      }
    }
  });
  closeButton.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      closeButton.click();
    }
  });
});
customElements.define('menu-drawer', MenuDrawer);
class HeaderLayer extends MenuDrawer {
  constructor() {
    super();
  }
  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    document.documentElement.style.setProperty('--header-bottom-position',`${parseInt(this.header.getBoundingClientRect().bottom)}px`);
    this.header.classList.add('menu-open');
    document.body.classList.add('menu_drawer_overlay');
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
  closeMenuDrawer(event, elementToFocus) {
    this.header = this.header || document.querySelector('.section-header');
    if (!elementToFocus) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });
      this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', false);
      this.mainDetailsToggle.removeAttribute('open');
      this.header?.classList.remove('menu-open');
      document.body.classList.remove('menu_drawer_overlay', `overflow-hidden-${this.dataset.breakpoint}`);
      window.removeEventListener('resize', this.onResize);
      return;
    }
    super.closeMenuDrawer(event, elementToFocus);
    this.header?.classList.remove('menu-open');
    document.body.classList.remove('menu_drawer_overlay');
    window.removeEventListener('resize', this.onResize);
  }
  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty('--header-bottom-position',`${parseInt(this.header.getBoundingClientRect().bottom)}px`);
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}
customElements.define('header-layer', HeaderLayer);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }
  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }
  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden', 'modal_view');
    this.classList.remove("close_popup");
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }
  hide() {
    document.body.classList.remove('overflow-hidden', 'modal_view');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.classList.add("close_popup");
    setTimeout(() => {
      this.removeAttribute('open');
      this.classList.remove("close_popup");
    }, 610);
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);
class BulkModal extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };
    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}
customElements.define('bulk-modal', BulkModal);
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.poster = this.querySelector('[id^="Deferred-Poster-"]');
    this.playButton = this.querySelector('.deferred-media__poster-button');
    this.isPlaying = false;
    if (!this.poster || !this.playButton) return;
    this.playButton.classList.add('play');
    this.poster.addEventListener('click', this.handleClick.bind(this));
  }
  async handleClick() {
    const isLoaded = this.getAttribute('loaded');
    const existingMedia = this.querySelector('video, model-viewer, iframe');
    if (!isLoaded) {
      const media = await this.loadContent(true);
      if(media){
        if (media.nodeName === 'VIDEO') {
          try {
            await media.play();
          } catch (e) {
            console.warn('Video autoplay failed:', e);
          }
        } else if (media.nodeName === 'IFRAME') {
          setTimeout(() => {
            this.togglePlayPause(media);
          }, 300);
        }
      }
    } else if (existingMedia) {
      this.togglePlayPause(existingMedia);
    }
  }
  loadContent(focus = true) {
    return new Promise((resolve) => {
      window.pauseAllMedia?.();
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
        this.deferredElement = deferredElement;
        const resolveWhenReady = () => resolve(deferredElement);
        if (deferredElement.nodeName === 'VIDEO') {
          deferredElement.setAttribute('playsinline', '');
          deferredElement.setAttribute('muted', '');
          deferredElement.addEventListener('loadeddata', resolveWhenReady, { once: true });
          deferredElement.addEventListener('pause', () => {
            this.isPlaying = false;
            this.playButton.classList.add('play');
          });
          deferredElement.addEventListener('play', () => {
            this.isPlaying = true;
            this.playButton.classList.remove('play');
          });
        } else if (deferredElement.nodeName === 'IFRAME') {
          deferredElement.onload = resolveWhenReady;
        } else {
          resolveWhenReady();
        }
      } else {
        resolve(this.deferredElement);
      }
    });
  }
  togglePlayPause(media) {
    const isYoutube = media.classList.contains('js-youtube');
    const isVimeo = media.classList.contains('js-vimeo');
    if (media.nodeName === 'VIDEO') {
      if (media.paused) {
        media.play();
      } else {
        media.pause();
      }
    } else if (isYoutube) {
      const func = this.isPlaying ? 'pauseVideo' : 'playVideo';
      media.contentWindow.postMessage(
        JSON.stringify({
          event: 'command',
          func: func,
          args: []
        }),
        '*'
      );
      this.isPlaying = !this.isPlaying;
      this.playButton.classList.toggle('play', !this.isPlaying);
    } else if (isVimeo) {
      const method = this.isPlaying ? 'pause' : 'play';
      media.contentWindow.postMessage(
        {
          method: method
        },
        '*'
      );
      this.isPlaying = !this.isPlaying;
      this.playButton.classList.toggle('play', !this.isPlaying);
    }
  }
}
customElements.define('deferred-media', DeferredMedia);
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.paginationDots = this.querySelectorAll('[data-slider-dot]');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    if (!this.slider || !this.nextButton) return;
    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);
    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    this.paginationDots.forEach((dot) => dot.addEventListener('click', this.onDotClick.bind(this)));
  }
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }
  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }
  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }
    if (this.paginationDots.length) {
      this.paginationDots.forEach((dot, index) => {
        const isActive = index + 1 === this.currentPage;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }
    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }
    if (this.enableSliderLooping) return;
    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }
    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }
  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }
  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }
  onDotClick(event) {
    event.preventDefault();
    const dotIndex = Number(event.currentTarget.dataset.sliderDot || 1) - 1;
    const targetSlide = this.sliderItemsToShow[dotIndex];
    if (!targetSlide) return;
    this.setSlidePosition(targetSlide.offsetLeft);
  }
  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
      behavior: 'smooth',
    });
  }
}
customElements.define('slider-component', SliderComponent);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }
  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;
    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`fieldset`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }
  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }
  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}
customElements.define('variant-selects', VariantSelects);
class ProductRecommendations extends HTMLElement {
  observer = undefined;
  constructor() {
    super();
  }
  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }
  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }
  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
        if (!this.querySelector('slider-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }
        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
customElements.define('product-recommendations', ProductRecommendations);
// Collapsible content
class ExpandContent extends HTMLElement {
  constructor() {
    super();
    this.justFocused = false;
    var collapse = this.getElementsByClassName("toggle");
    Array.from(collapse).forEach((ele) => {
      ele.setAttribute('tabindex', '0');
      var content_data = ele.nextElementSibling;
      var defaultOpen = ele.classList.contains("active");
      if (content_data && !defaultOpen) {
        content_data.style.height = '0px';
        content_data.setAttribute('data-collapsed', 'true');
        this.setInnerTabIndex(content_data, -1);
      } else {
        this.setInnerTabIndex(content_data, 0);
      }
      ele.addEventListener("click", this.onCollapseClick.bind(this));
      ele.addEventListener('keydown', this.handleKeyDown.bind(this));
      ele.addEventListener("focus", this.onFocusOpen.bind(this));
    });
  }
  handleKeyDown(event) {
    if (event.keyCode === 13) {
      this.onCollapseClick(event);
    }
  }
  onFocusOpen(event) {
    if (this.classList.contains('product_info_collapse')) {
      return;
    }
    const target = event.currentTarget;
    const content_data = target.nextElementSibling;
    const isCollapsed = content_data?.getAttribute('data-collapsed') === 'true';
    if (content_data && isCollapsed) {
      this.justFocused = true;
      target.classList.add("active");
      this.expandCollapse(content_data);
    }
  }
  onCollapseClick(event) {
    if (this.justFocused && event.type === 'click') {
      this.justFocused = false;
      return;
    }
    this.justFocused = false;
    event.currentTarget.classList.toggle("active");
    var content_data = event.currentTarget.nextElementSibling;
    if (!content_data) return;
    var isCollapsed = content_data.getAttribute('data-collapsed') === 'true';
    if (isCollapsed) {
      this.expandCollapse(content_data);
    } else {
      this.allCollapse(content_data);
    }
  }
  expandCollapse(element) {
    var collapseHeight = element.scrollHeight;
    element.style.height = collapseHeight + 'px';
    element.style.visibility = 'visible';
    element.setAttribute('data-collapsed', 'false');
    this.setInnerTabIndex(element, 0);
    element.addEventListener('transitionend', () => {
      element.removeEventListener('transitionend', this.expandCollapse);
      element.style.height = null;
      element.style.visibility = 'visible';
    });
  }
  allCollapse(element) {
    var collapseHeight = element.scrollHeight;
    element.style.height = collapseHeight + 'px';
    element.offsetHeight;
    element.style.transition = 'height 0.3s ease';
    element.style.height = '0px';
    element.setAttribute('data-collapsed', 'true');
    this.setInnerTabIndex(element, -1);
    element.addEventListener('transitionend', () => {
      element.removeEventListener('transitionend', this.allCollapse);
      element.style.transition = '';
      element.style.height = '0px';
      element.style.visibility = 'hidden';
    });
  }
  setInnerTabIndex(container, value) {
    if (!container) return;
    const focusable = container.querySelectorAll('a, button, input, textarea, select, [tabindex]');
    focusable.forEach(el => {
      if (value === -1 || (value === 0 && el.hasAttribute('tabindex'))) {
        el.setAttribute('tabindex', value);
      }
    });
  }
}
customElements.define('expand-content', ExpandContent);
class AccountIcon extends HTMLElement {
  constructor() {
    super();
    this.icon = this.querySelector('.icon');
  }
  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }
  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}
customElements.define('account-icon', AccountIcon);
// Variant hover
class ColorSwatch extends VariantSelects {
  constructor() { 
    super();
    const fieldsets = Array.from(this.querySelectorAll('fieldset label'));
    this.querySelectorAll('fieldset label').forEach((ele)=>{
      ele.addEventListener('mouseenter', this.onVariantChangeHover.bind(this));
      ele.addEventListener('click', this.onLabelClick.bind(this));
    }) 
  }
  onLabelClick(event){
    if(event.target.dataset.href){
      window.location.href = event.target.dataset.href;
    }
  }
  updatelabelDataset(ele){
    let href = ele.dataset.href;
    let optionValuesStr = '';
    if (this.selectedOptionValues.length) {
          optionValuesStr=this.selectedOptionValues.join(',');
    }
    if(href.indexOf('?option_values=') > -1){
      href = (href.substring(0, href.indexOf('?option_values=')+15) + optionValuesStr)
    }else{
      href += ("?option_values="+ optionValuesStr)
    }
    ele.dataset.href = href; 
  }
  onVariantChangeHover(event){
    this.querySelector('#'+event.target.getAttribute('for')).click();
    this.updatelabelDataset(event.target);
  }
}
customElements.define('color-swatch', ColorSwatch);
// Carousel
class SliderCarousel extends HTMLElement {
  constructor() {
    super();
    let optionsData = {};
    let defaults = {};
    let autoplay = false;
    if(this.dataset.sectionSetting){
      const sectionSetting = JSON.parse(this.dataset.sectionSetting);
      const space = +this.dataset.spacingGridHorizontal;
      const spacemobile =  +this.dataset.spacingGridHorizontal/2;
      optionsData = {
        slidesPerView: sectionSetting.columns_desktop ? sectionSetting.columns_desktop : 1,
        spaceBetween: space,
        loop: false,
        speed: 600,
        grabCursor: true,
        dragClickables: false,
        updateOnWindowResize: true,
        breakpoints: {
          0: {
            spaceBetween: spacemobile,
          },
          768: {
            slidesPerView: sectionSetting.columns_desktop,
            spaceBetween: spacemobile,
          },
          992: {
            slidesPerView: sectionSetting.columns_desktop,
            spaceBetween: space,
          }
        }
      };
      if(sectionSetting.enable_loop == true){
        optionsData['loop'] = {
          loop: true,
          rewind: true,
        };
      }
      if(this.dataset.breakpoints){
        const breakpoints = JSON.parse(this.dataset.breakpoints)
        for (const key in breakpoints) {
          if(key <=768){
            let obj = {
              slidesPerView: breakpoints[key],
              spaceBetween: spacemobile,
            }
            optionsData['breakpoints'][key] = obj
          }else{
            let customspaceBetween = space
            let breakpointsKey = key
            if(key.indexOf('m') > -1){ 
              breakpointsKey = key.split('-')[1]
              customspaceBetween = spacemobile
            }
            let obj = {
              slidesPerView: breakpoints[key],
              spaceBetween: customspaceBetween,
            }
            optionsData['breakpoints'][breakpointsKey] = obj
          }
        }
      }
      if(sectionSetting.auto_rotate == true){
        autoplay = true;
        optionsData['autoplay'] = {
          delay: sectionSetting.change_slides_speed * 1000,
          disableOnInteraction: false,
        };
      }
      let paginateArrow = this.querySelector('.swiper-pagination') ? true : false;
      if(paginateArrow){
        optionsData['pagination'] = {
          el: ".swiper-pagination",
          clickable: 'true',
        };
      }
      let buttonArrow = this.querySelector('.slider_arows') ? this.querySelector('.slider_arows').getAttribute('data-button-type') : false;
      if(buttonArrow == 'arrow'){
        optionsData['navigation'] = {
          nextEl: `.swiper-button-next`,
          prevEl: `.swiper-button-prev`,
        };
      }
    }
    this.options = {
      ...defaults,
      ...optionsData
    };
    const swiperInstance = new Swiper(this.querySelector('.swiper'), this.options);
      const prevButton = this.querySelector('.swiper-button-prev .button, .slider-button--prev .button'),
            nextButton = this.querySelector('.swiper-button-next .button, .slider-button--next .button'),
            btnParent = this.querySelector('.slide_out_btn'),
            btnWidth = 50;
      let isHovering = false, 
      previousIndex = 0, 
      activeClickIndex = null;
      const updateButtonState = i => {
        activeClickIndex = i;
        prevButton?.classList.toggle('btn_clicked', i === 0);
        nextButton?.classList.toggle('btn_clicked', i === 1);
        btnParent?.style.setProperty('--btn_slide', `${btnWidth * i}%`);
      };
      swiperInstance.on('slideChange', () => {
        const i = swiperInstance.activeIndex, d = i - previousIndex;
        if (d !== 0) updateButtonState(d > 0 ? 1 : 0);
        previousIndex = i;
      });
      [prevButton, nextButton].forEach((btn, i) => {
        btn?.addEventListener('mouseenter', () => {
          isHovering = true;
          prevButton?.classList.remove('btn_clicked');
          nextButton?.classList.remove('btn_clicked');
          btn.classList.add('btn_clicked');
          btnParent?.style.setProperty('--btn_slide', `${btnWidth * i}%`);
        });
        btn?.addEventListener('mouseleave', () => {
          isHovering = false;
          if (activeClickIndex !== null) updateButtonState(activeClickIndex);
        });
        btn?.addEventListener('click', () => {
          isHovering = false;
          updateButtonState(i);
        });
      });
  }
  connectedCallback() { }
}
customElements.define('slider-carousel', SliderCarousel);
class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.requestStarted = false;
    this.ids = [];
  }
  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  }
  sendRequest(queue) {
    this.requestStarted = true;
    const items = {};
    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
    quickBulkElement.updateMultipleQty(items);
  }
  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }
  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }
  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.startQueue(index, inputValue);
    }
  }
  getSectionsUrl() {
    if (window.pageNumber) {
      return `${window.location.pathname}?page=${window.pageNumber}`;
    } else {
      return `${window.location.pathname}`;
    }
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}
if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}
// header position height count
let headerFound = document.querySelector('header.header');
if (headerFound) {
  let headerPosition = headerFound.getBoundingClientRect();
  let headerPositionTop = headerPosition.top + window.scrollY;
  document.documentElement.style.setProperty('--header-position', `${headerPositionTop}px`);
  const body = document.querySelector('body');
  if (body) {
    body.style.setProperty('--header-position', `${headerPositionTop}px`);
  }
}
// Timer js
setInterval(countDown, 1000);
function countDown() {
  const countCardSections = document.querySelectorAll('.count_des');
  countCardSections.forEach((countdownSection) => {
    var countDownDate = new Date(countdownSection.getAttribute('data-timer-date')).getTime();
    var now = new Date().getTime();
    var distance = countDownDate - now;
    if (distance < 0 || isNaN(countDownDate)) {
      countdownSection.querySelector('.ct_day .bz_cdays').textContent = "00";
      countdownSection.querySelector('.ct_hour .bz_chours').textContent = "00";
      countdownSection.querySelector('.ct_minit .bz_cminutes').textContent = "00";
      countdownSection.querySelector('.ct_second .bz_cseconds').textContent = "00";
    } else {
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      days = days < 10 ? "0" + days : days;
      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      countdownSection.querySelector('.ct_day .bz_cdays').textContent = days;
      countdownSection.querySelector('.ct_hour .bz_chours').textContent = hours;
      countdownSection.querySelector('.ct_minit .bz_cminutes').textContent = minutes;
      countdownSection.querySelector('.ct_second .bz_cseconds').textContent = seconds;
    }
  });
}
// video pause js
document.addEventListener('DOMContentLoaded', function () {
  const gallery = document.querySelector('[id^="MediaGallery"]');
  if (!gallery) return;
  const youtubePlayers = new Map();
  let youtubeAPILoaded = false;
  function loadYouTubeAPI() {
    if (youtubeAPILoaded) return;
    youtubeAPILoaded = true;
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
  function pauseAllVideos(exceptVideo = null) {
    // Pause all HTML5 videos except the one passed
    const allVideos = gallery.querySelectorAll('video');
    allVideos.forEach((video) => {
      if (video !== exceptVideo && !video.paused) {
        video.pause();
      }
    });
    // Pause all YouTube videos except the one passed
    youtubePlayers.forEach((player, iframe) => {
      if (iframe !== exceptVideo) {
        player.pauseVideo();
      }
    });
    // reset 3d model
    document.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }
  gallery.addEventListener('click', function (event) {
    const clickedMedia = event.target.closest('[data-media-id]');
    if (!clickedMedia) return;
    const clickedVideo = clickedMedia.querySelector('video');
    if (clickedVideo) {
      pauseAllVideos(clickedVideo);
    }
    const clickedIframe = clickedMedia.querySelector('iframe');
    if (clickedIframe && clickedIframe.src.includes('youtube.com')) {
      pauseAllVideos(clickedIframe);
    }
  });
  const observer = new MutationObserver(() => {
    // Add play event listeners to all HTML5 videos
    const allVideos = gallery.querySelectorAll('video');
    allVideos.forEach((video) => {
      video.addEventListener('play', () => {
        pauseAllVideos(video);
      });
    });
    // Find all YouTube iframes
    const iframes = gallery.querySelectorAll('iframe[src*="youtube.com"]');
    if (iframes.length > 0) {
      loadYouTubeAPI();
      // If YouTube API is already loaded, create players for new iframes
      if (window.YT && window.YT.Player) {
        iframes.forEach((iframe) => {
          if (!youtubePlayers.has(iframe)) {
            const player = new YT.Player(iframe, {
              events: {
                onStateChange: function (event) {
                  if (event.data === YT.PlayerState.PLAYING) {
                    pauseAllVideos(iframe);
                  }
                }
              }
            });
            youtubePlayers.set(iframe, player);
          }
        });
      }
    }
  });
  observer.observe(gallery, {
    childList: true,
    subtree: true,
  });
  // This is called once YouTube iframe API is ready
  window.onYouTubeIframeAPIReady = function () {
    const iframes = gallery.querySelectorAll('iframe[src*="youtube.com"]');
    iframes.forEach((iframe) => {
      if (!youtubePlayers.has(iframe)) {
        const player = new YT.Player(iframe, {
          events: {
            onStateChange: function (event) {
              if (event.data === YT.PlayerState.PLAYING) {
                pauseAllVideos(iframe);
              }
            }
          }
        });
        youtubePlayers.set(iframe, player);
      }
    });
  };
});
// button js
document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.slide_out_btn .button');
  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const sectionId = button.closest('.slide_out_btn').getAttribute('data-section-id');
      const sectionButtons = document.querySelectorAll(`.slide_out_btn[data-section-id="${sectionId}"] .button`);
      sectionButtons.forEach(btn => btn.classList.remove('btn_clicked'));
      button.classList.add('btn_clicked');
    });
  });
});
const btnWidth = 50;
function slideBg(n, section) {
    const btnParent = document.querySelector(`.${section} .slide_out_btn`);
    if(btnParent){
      const btnSpace = btnWidth * n;
      btnParent.style.setProperty("--btn_slide", `${btnSpace}%`);
    }
}
document.querySelectorAll('.banner-content-remove').forEach((close) => {
  close.addEventListener('click', (event) => {
    const parentElement = event.currentTarget.closest('.video_info');
    if (parentElement) {
      parentElement.remove();
    }
  });
});
//blog left sidebar drawer
class ArticleToggle extends HTMLElement {
  constructor() {
    super();
    this.sidebar = this.querySelector('.sidebar');
    this.toggleButton = this.querySelector('.toggle-button');
    this.closeBtn = this.querySelector('.sidebar-close');
    this.toggleButton.addEventListener('click', this.toggleSidebar.bind(this));
    this.closeBtn.addEventListener('click', this.closeSidebar.bind(this));
    document.addEventListener('click', this.handleOutsideClick.bind(this));
    document.addEventListener('keydown', this.handleTabKey.bind(this));
  }
  toggleSidebar() {
    this.sidebar.classList.add('active');
    document.body.classList.add("overflow-hidden");
    this.focusableElements = this.sidebar.querySelectorAll(
      'a, button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    this.firstFocusable = this.focusableElements[0];
    this.lastFocusable = this.focusableElements[this.focusableElements.length - 1];
    // this.firstFocusable?.focus();
  }
  closeSidebar() {
    this.sidebar.classList.remove('active');
    document.body.classList.remove("overflow-hidden");
  }
  handleOutsideClick(event) {
    if (
      this.sidebar.classList.contains('active') &&
      !this.sidebar.contains(event.target) &&
      !this.toggleButton.contains(event.target)
    ) {
      this.closeSidebar();
    }
  }
  handleTabKey(e) {
    if (!this.sidebar.classList.contains('active')) return;
    if (e.key !== 'Tab') return;
    const focusable = this.focusableElements;
    if (focusable.length === 0) return;
    if (e.shiftKey) {
      if (document.activeElement === this.firstFocusable) {
        e.preventDefault();
        this.lastFocusable.focus();
      }
    } else {
      if (document.activeElement === this.lastFocusable) {
        e.preventDefault();
        this.firstFocusable.focus();
      }
    }
  }
}
customElements.define('article-toggle', ArticleToggle);

document.addEventListener('DOMContentLoaded', function () {
  const stickySection = document.querySelector('.product_sticky_section');
  const header = document.querySelector('header');
  if (!header) return; // Exit if no header
  let headerTHeight = header.offsetHeight;
  function setHeaderHeight() {
    document.documentElement.style.setProperty('--header_theight', `${headerTHeight}px`);
  }
  setHeaderHeight();
  if (stickySection) {
    let stickySectionOffset = stickySection.offsetTop - headerTHeight;
    window.addEventListener('scroll', function () {
      headerTHeight = header.offsetHeight;
      stickySectionOffset = stickySection.offsetTop - headerTHeight;
      if (window.pageYOffset > stickySectionOffset) {
        stickySection.classList.add('sticky-top');
      } else {
        stickySection.classList.remove('sticky-top');
      }
      setHeaderHeight();
    });
  }
  const tabs = document.querySelectorAll(".sticky-tabs .nav-item");
  if (tabs.length > 0) {
    tabs.forEach(tab => {
      tab.addEventListener("click", function () {
        tabs.forEach(t => t.classList.remove("active"));
        this.classList.add("active");
      });
    });
  }
});
class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.loadMoreProducts = this.loadMoreProducts.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.addEventListener('click', this.loadMoreProducts);
    this.addEventListener('keydown', this.handleKeyDown);
    const productGridElement = document.getElementById('product-grid');
    if (productGridElement) {
      this.next_url = productGridElement.dataset.nextUrl;
    }
    this.loadMoreBtn = this.querySelector('.button');
  }
  handleKeyDown(e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();
      this.loadMoreProducts();
    }
  }
  async getNextPage() {
    try {
      const response = await fetch(this.next_url);
      return await response.text();
    } catch (error) {
      console.error("Error fetching next page:", error);
      return null;
    }
  }
  async loadMoreProducts() {
    const load_more_spinner = this.querySelector('.load-more_spinner');
    if (!this.next_url || !load_more_spinner) return;
    if (this.loadMoreBtn) this.loadMoreBtn.style.display = 'none';
    load_more_spinner.style.display = 'block';
    const nextPage = await this.getNextPage();
    if (!nextPage) return;
    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');
    const productgrid = nextPageDoc.getElementById('product-grid');
    const new_products = productgrid ? productgrid.getElementsByClassName('grid__item') : [];
    const new_url = productgrid ? productgrid.dataset.nextUrl : null;
    this.next_url = new_url;
    load_more_spinner.style.display = 'none';
    if (new_url && this.loadMoreBtn) {
      this.loadMoreBtn.style.display = 'inline-flex';
    }
    const productGridContainer = document.getElementById('product-grid');
    const productsArray = Array.from(new_products);
    productsArray.forEach(product => {
      if (!product.classList.contains('bzimgbnrblock')) {
        productGridContainer.appendChild(product);
      }
    });
    const productCountText = document.getElementById('product-count-text');
    const totalProducts = parseInt(productCountText?.dataset.totalProducts || '0', 10);
    const currentlyVisible = productGridContainer.querySelectorAll('.grid__item:not(.bzimgbnrblock)').length;
    if (productCountText) {
      productCountText.textContent = `Viewing 1–${currentlyVisible} out of ${totalProducts} products`;
    }
    if (!new_url || currentlyVisible >= totalProducts) {
      this.style.display = 'none';
    }
    const progressFill = document.getElementById('product-progress-fill');
    if (progressFill) {
      const progressPercent = (currentlyVisible / totalProducts) * 100;
      progressFill.style.width = `${Math.min(progressPercent, 100)}%`;
    }
  }
}
customElements.define('load-more', LoadMore);
// product auto banner
let productbnerSections = [],
    lstScrollY = 0,
    isManualScrolling = false;

function initBnerScrollSections() {
  productbnerSections = [];
  const sections = document.querySelectorAll('[class*="section-"][class*="-mainsec"]');
  sections.forEach(section => {
    const heightWrapper = section.querySelector('.product_sec_height'),
          mainBanner = section.querySelector('.main_banner'),
          smallBanner = section.querySelector('.small_banner'),
          thumbnails = section.querySelectorAll('.small_banner .product-slide'),
          outsideButtons = section.querySelectorAll('.outside_main .button');

    if (!mainBanner || !smallBanner || !heightWrapper) return;

    const swiperContainer = section.querySelector('.swiper-container.gallery-slider');
    const mainHeights = [...mainBanner.children].map(el => el.offsetHeight),
          smallHeights = [...smallBanner.children].map(el => el.offsetHeight),
          totalHeight = mainHeights.reduce((a, h) => a + h, 0);

    heightWrapper.style.height = `${totalHeight}px`;

    const maxSmallIndex = Math.min(3, smallHeights.length - 1),
          maxSmallTranslateY = smallHeights.slice(0, maxSmallIndex + 1).reduce((a, h) => a + h, 0) + (maxSmallIndex * 15);

    productbnerSections.push({
      section,
      mainBanner,
      smallBanner,
      thumbnails,
      outsideButtons,
      mainHeights,
      smallHeights,
      totalHeight,
      index: 0,
      currentOffset: 0,
      maxSmallTranslateY,
      maxSmallIndex
    });

    thumbnails.forEach((thumb, i) => {
      thumb.setAttribute('tabindex', '0');
      thumb.setAttribute('role', 'button');
      thumb.setAttribute('aria-label', `View product ${i + 1}`);
      thumb.addEventListener('mouseenter', () => onThumbnailClick(i, section, thumbnails));
      thumb.addEventListener('focus', () => {
        if (swiperContainer) swiperContainer.style.overflow = 'visible';
        onThumbnailClick(i, section, thumbnails);
      });
      thumb.addEventListener('focusout', () => {
        if (swiperContainer) swiperContainer.style.overflow = 'hidden';
      });
      thumb.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
        }
      });
    });

    outsideButtons.forEach((btn, i) => {
      btn.setAttribute('tabindex', '0');
      btn.setAttribute('role', 'button');
      btn.setAttribute('aria-label', `View product button ${i + 1}`);

      btn.addEventListener('focus', () => {
        if (swiperContainer) swiperContainer.style.overflow = 'visible';
        onOutsideButtonFocus(section, i);
      });

      btn.addEventListener('focusout', () => {
        if (swiperContainer) swiperContainer.style.overflow = 'hidden';
      });

      btn.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
        }
      });
    });
  });

  initWheelScrollForMainBanner();
}

function onThumbnailClick(index, section, thumbnails) {
  const b = productbnerSections.find(b => b.section === section);
  if (!b) return;

  isManualScrolling = true;
  b.index = index;

  b.thumbnails.forEach((thumb, i) => {
    thumb.classList.toggle('active', i === b.index);
    thumb.classList.toggle('active_hover', i === b.index);
  });

  b.outsideButtons.forEach((btn, i) => {
    btn.classList.toggle('active', false);
  });

  b.currentOffset = b.mainHeights.slice(0, b.index).reduce((a, h) => a + h, 0);
  b.mainBanner.style.transform = `translateY(-${b.currentOffset}px)`;

  if (window.innerWidth <= 767 && b.thumbnails.length) {
    const computedStyle = getComputedStyle(b.section);
    const gapRaw = computedStyle.getPropertyValue('--grid-desktop-horizontal-spacing') || '0px';
    const gapValue = parseFloat(gapRaw) || 0;
    const halfGap = gapValue / 2;
    const slideWidths = [...b.thumbnails].map(el => el.offsetWidth);
    const xOffset = slideWidths.slice(0, b.index).reduce((a, w) => a + w, 0);
    const totalGapOffset = halfGap * b.index;
    b.smallBanner.style.transform = `translateX(-${xOffset + totalGapOffset}px)`;
  }

  const scrollTarget = b.section.offsetTop + b.currentOffset;
  window.scrollTo({
    top: scrollTarget,
    behavior: 'smooth'
  });

  setTimeout(() => {
    lstScrollY = scrollTarget;
    isManualScrolling = false;
  }, 400);
}

function onOutsideButtonFocus(section, buttonIndex) {
  const b = productbnerSections.find(b => b.section === section);
  if (!b) return;

  isManualScrolling = true;

  const indexToFocus = Math.min(buttonIndex, b.mainHeights.length - 1);
  b.index = indexToFocus;

  b.thumbnails.forEach((thumb, i) => {
    thumb.classList.toggle('active', i === b.index);
    thumb.classList.toggle('active_hover', i === b.index);
  });

  b.outsideButtons.forEach((btn, i) => {
    btn.classList.toggle('active', i === b.index);
  });

  b.currentOffset = b.mainHeights.slice(0, b.index).reduce((a, h) => a + h, 0);
  b.mainBanner.style.transform = `translateY(-${b.currentOffset}px)`;

  if (window.innerWidth <= 767 && b.thumbnails.length) {
    const computedStyle = getComputedStyle(b.section);
    const gapRaw = computedStyle.getPropertyValue('--grid-desktop-horizontal-spacing') || '0px';
    const gapValue = parseFloat(gapRaw) || 0;
    const halfGap = gapValue / 2;
    const slideWidths = [...b.thumbnails].map(el => el.offsetWidth);
    const xOffset = slideWidths.slice(0, b.index).reduce((a, w) => a + w, 0);
    const totalGapOffset = halfGap * b.index;
    b.smallBanner.style.transform = `translateX(-${xOffset + totalGapOffset}px)`;
  }

  const scrollTarget = b.section.offsetTop + b.currentOffset;
  window.scrollTo({
    top: scrollTarget,
    behavior: 'smooth'
  });

  setTimeout(() => {
    lstScrollY = scrollTarget;
    isManualScrolling = false;
  }, 400);
}

function updateBnerOnScroll() {
  if (isManualScrolling) return;

  const y = scrollY;
  const windowHeight = window.innerHeight;

  productbnerSections.forEach(b => {
    const sectionTop = b.section.offsetTop;
    const sectionBottom = sectionTop + b.totalHeight;

    if (window.innerWidth > 1199) {
      if (y < sectionTop || y > sectionBottom) return;
      const dir = y > lstScrollY ? 1 : -1;
      const currentHeight = b.mainHeights[b.index];
      const trigger = sectionTop + b.mainHeights.slice(0, b.index + 1).reduce((a, h) => a + h, 0) - currentHeight / 2;
      if (dir > 0 && y > trigger && b.index < b.mainHeights.length - 1) b.index++;
      else if (dir < 0 && y < trigger - currentHeight && b.index > 0) b.index--;
    } else {
      const sectionHeight = sectionBottom - sectionTop;
      const scrollProgress = (y - sectionTop) / sectionHeight;
      const progress = Math.max(0, Math.min(scrollProgress, 1));
      const index = Math.min(
        b.mainHeights.length - 1,
        Math.floor(progress * b.mainHeights.length)
      );
      b.index = index;
    }

    b.currentOffset = b.mainHeights.slice(0, b.index).reduce((a, h) => a + h, 0);
    b.mainBanner.style.transform = `translateY(-${b.currentOffset}px)`;

    if (window.innerWidth <= 767 && b.thumbnails.length) {
      const computedStyle = getComputedStyle(b.section);
      const gapRaw = computedStyle.getPropertyValue('--grid-desktop-horizontal-spacing') || '0px';
      const gapValue = parseFloat(gapRaw) || 0;
      const halfGap = gapValue / 2;
      const slideWidths = [...b.thumbnails].map(el => el.offsetWidth);
      const xOffset = slideWidths.slice(0, b.index).reduce((a, w) => a + w, 0);
      const totalGapOffset = halfGap * b.index;
      b.smallBanner.style.transform = `translateX(-${xOffset + totalGapOffset}px)`;
    }

    b.thumbnails.forEach((thumb, i) => {
      thumb.classList.toggle('active', i === b.index);
      thumb.classList.toggle('active_hover', i === b.index);
    });

    b.outsideButtons.forEach((btn, i) => {
      btn.classList.toggle('active', i === b.index);
    });
  });

  lstScrollY = y;
}

function initWheelScrollForMainBanner() {
  productbnerSections.forEach(b => {
    let isScrolling = false;
    b.mainBanner.addEventListener('wheel', function(e) {
      if (window.innerWidth <= 1200 || isScrolling) return;

      const direction = e.deltaY > 0 ? 1 : -1;
      const nextIndex = b.index + direction;
      if (nextIndex < 0 || nextIndex >= b.mainHeights.length) return;

      e.preventDefault();
      isScrolling = true;
      b.index = nextIndex;

      const stepHeight = b.mainHeights[b.index] || 0;
      b.currentOffset += direction * stepHeight;
      b.currentOffset = Math.max(0, Math.min(b.currentOffset, b.totalHeight));
      b.mainBanner.style.transform = `translateY(-${b.currentOffset}px)`;

      b.thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle('active', i === b.index);
        thumb.classList.toggle('active_hover', i === b.index);
      });

      b.outsideButtons.forEach((btn, i) => {
        btn.classList.toggle('active', i === b.index);
      });

      const scrollTarget = b.section.offsetTop + b.currentOffset;
      window.scrollTo({ top: scrollTarget, behavior: 'smooth' });

      setTimeout(() => {
        lstScrollY = scrollTarget;
        isScrolling = false;
      }, 400);
    }, { passive: false });
  });
}

initBnerScrollSections();
addEventListener('scroll', updateBnerOnScroll);
[
  'DOMContentLoaded',
  'resize',
  'shopify:section:load',
  'shopify:section:unload',
  'shopify:section:select',
  'shopify:section:deselect',
  'shopify:section:reorder'
].forEach(event => addEventListener(event, () => {
  initBnerScrollSections();
}));
// product auto banner end

const bzQuickViewCache = window.bzQuickViewCache || new Map();
window.bzQuickViewCache = bzQuickViewCache;

function getBzQuickViewUrl(button) {
  if (!button?.dataset?.url || !button.dataset.template) return null;
  const productUrl = button.dataset.url.split('?')[0];
  return `${productUrl}?view=${button.dataset.template}${button.dataset.variantid ? `&variant=${button.dataset.variantid}` : ''}`;
}

function fetchBzQuickView(url) {
  if (!url) return Promise.resolve('');
  if (!bzQuickViewCache.has(url)) {
    bzQuickViewCache.set(
      url,
      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error(`Quick view request failed: ${response.status}`);
          return response.text();
        })
        .catch(error => {
          bzQuickViewCache.delete(url);
          throw error;
        })
    );
  }
  return bzQuickViewCache.get(url);
}

class BzQuickView extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.bzPopUp.bind(this));
    this.addEventListener('pointerenter', this.prefetch.bind(this), { passive: true });
    this.addEventListener('focusin', this.prefetch.bind(this));
    this.addEventListener('touchstart', this.prefetch.bind(this), { passive: true });
  }
  prefetch(e) {
    const button = e.target.closest('button[data-template][data-url]');
    const fetchUrl = getBzQuickViewUrl(button);
    if (fetchUrl) fetchBzQuickView(fetchUrl).catch(() => {});
  }
  bzPopUp(e) {
    const button = e.target.closest('button');
    if (!button) return;
    e.preventDefault();
    button.classList.add('loading');
    const spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
    button.setAttribute('disabled', 'true');
    const fetchUrl = getBzQuickViewUrl(button);
    fetchBzQuickView(fetchUrl)
      .then(data => {
        if (!data) return;
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(data, 'text/html');
        const content = htmlDoc.querySelector('[data-html="content"]');
        if (!content) throw new Error('Quick view content was not found');
        const html = content.innerHTML;
        const modalContainer = document.querySelector(".js-quick_view");
        if (modalContainer) {
          document.body.classList.add('overflow-hidden', 'modal_view');
          modalContainer.innerHTML = html;
          const modalEl = modalContainer.querySelector('bz-modal');
          if (modalEl) {
            modalEl._openerButton = button;
            const modalContent = modalEl.querySelector('.quick-add-modal__content');
            if (modalContent) {
              setTimeout(() => {
                modalContent.classList.add('wbmodl');
              }, 100);
              trapFocus(modalContent);
              modalContent.focus();
            }
          }
          if (window.ProductModel) window.ProductModel.loadShopifyXR();
        }
        button.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        button.removeAttribute('disabled');
      })
      .catch(error => {
        console.error('Error:', error);
        button.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        button.removeAttribute('disabled');
      });
  }
}
customElements.define('bz-quick-view', BzQuickView);
class BzModal extends HTMLElement {
  constructor() {
    super();
    this.closeEl = this.querySelector(".modal__close");
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }
  connectedCallback() {
    if (this.closeEl) {
      this.closeEl.addEventListener('click', this.close.bind(this));
    }
    document.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('click', this.handleClickOutside);
  }
  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('click', this.handleClickOutside);
  }
  handleKeyDown(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      this.close();
    }
  }
  handleClickOutside(event) {
    if (
      !event.target.closest('.common_modal') &&
      !event.target.closest('modal-dialog.product-popup-modal')
    ) {
      this.close();
    }
  }
  close() {
    this.classList.add("close_popup");
    const modalEl = this;
    const openerBtn = this._openerButton;
    setTimeout(() => {
      modalEl.remove();
      document.body.classList.remove('overflow-hidden', 'modal_view');
      if (openerBtn && typeof openerBtn.focus === 'function') {
        openerBtn.focus();
      }
    }, 80);
  }
}
customElements.define('bz-modal', BzModal);
// sticky cart height
const stickyElement = document.querySelector('.sticky_pro_page');
if (stickyElement) {
  const stickyHeight = stickyElement.offsetHeight;
  document.documentElement.style.setProperty('--sticky-pro-page-height', `${stickyHeight}px`);
}
// banner content height
const bannerContent = document.querySelector('.banner__contents ');
if (bannerContent) {
  const bannerContentHeight = bannerContent.offsetHeight;
  document.documentElement.style.setProperty('--banner-content-height', `${bannerContentHeight}px`);
}
// page scrollbar width
function updateScrollbarWidth() {
  const scrollbar = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--scrollbar-width', `${scrollbar}px`);
}
document.addEventListener('DOMContentLoaded', updateScrollbarWidth);
window.addEventListener('resize', updateScrollbarWidth);
let tabFocus = false;
document.addEventListener('keydown', function(e) {
  if (e.key === 'Tab') {
    tabFocus = true;
  }
});
document.addEventListener('focusin', function(e) {
  if (tabFocus && e.target.matches('[name="quickView"]')) {
    e.target.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest'
    });
  }
  if (tabFocus && e.target.matches('.featured_prd_title')) {
    e.target.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest'
    });
  }
});

// compare image
function initComparisonSlider(scope = document) {

  var comparisonSliders = scope.querySelectorAll(".comparison-slider");
  if (!comparisonSliders.length) return;

  comparisonSliders.forEach(function (compSlider) {
    if (compSlider.classList.contains('slider-initialized')) return;
    compSlider.classList.add('slider-initialized');
    var resizeImage = compSlider.querySelector(".resize .compare__image");
    var divider = compSlider.querySelector(".divider");
    var resize = compSlider.querySelector(".resize");

    if (!resizeImage || !divider || !resize) return;

    function setWidth() {
      resizeImage.style.width = compSlider.offsetWidth + "px";
    }

    setWidth();
    window.addEventListener("resize", setWidth);

    drags(divider, resize, compSlider);

    const observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !entry.target.classList.contains('animated')) {
          divider.style.transition = "left 0.9s ease";
          resize.style.transition = "width 0.9s ease";
          divider.style.left = "50%";
          resize.style.width = "50%";
          entry.target.classList.add('animated');
          observer.unobserve(entry.target);
          setTimeout(function () {
            divider.style.transition = "none";
            resize.style.transition = "none";
          }, 900);
        }
      });
    }, { threshold: 0.6 });

    observer.observe(compSlider);
  });
}
document.addEventListener("DOMContentLoaded", function () {
  initComparisonSlider(document);
});
document.addEventListener("shopify:section:load", function (e) {
  initComparisonSlider(e.target);
});
function drags(dragElement, resizeElement, container) {
  var touched = false;
  window.addEventListener('touchstart', function () {
      touched = true;
  });
  window.addEventListener('touchend', function () {
      touched = false;
  });
  dragElement.addEventListener("mousedown", startDragging);
  dragElement.addEventListener("touchstart", startDragging);
  function startDragging(e) {
      e.preventDefault();
      dragElement.classList.add("draggable");
      resizeElement.classList.add("resizable");
      var startX = e.pageX || e.touches[0].pageX;
      var dragWidth = dragElement.offsetWidth;
      var posX = dragElement.offsetLeft + dragWidth - startX;
      var containerOffset = container.offsetLeft;
      var containerWidth = container.offsetWidth;
      var minLeft = containerOffset + 10;
      var maxLeft = containerOffset + containerWidth - dragWidth - 10;
      function dragMove(e) {
        if (!touched) {
            e.preventDefault();
        }
        var moveX = e.pageX || (e.touches && e.touches.length > 0 ? e.touches[0].pageX : undefined);
        var leftValue = moveX + posX - dragWidth;
        if (leftValue < minLeft) {
            leftValue = minLeft;
        } else if (leftValue > maxLeft) {
            leftValue = maxLeft;
        }
        var widthValue = ((leftValue + dragWidth / 2 - containerOffset) * 100 / containerWidth) + "%";
        dragElement.style.left = widthValue;
        resizeElement.style.width = widthValue;
    }
      function dragEnd() {
          dragElement.classList.remove("draggable");
          resizeElement.classList.remove("resizable");
          document.removeEventListener("mousemove", dragMove);
          document.removeEventListener("mouseup", dragEnd);
          document.removeEventListener("touchmove", dragMove);
          document.removeEventListener("touchend", dragEnd);
          document.removeEventListener("touchcancel", dragEnd);
      }
      document.addEventListener("mousemove", dragMove);
      document.addEventListener("mouseup", dragEnd);
      document.addEventListener("touchmove", dragMove);
      document.addEventListener("touchend", dragEnd);
      document.addEventListener("touchcancel", dragEnd);
  }
}

// youtube video for performance
class YouTubeVideo extends HTMLElement {
  constructor() {
    super();
    this.template = this.querySelector('template');
    this.iframeLoaded = false;

    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.iframeLoaded) {
            this.loadIframe();
          }
        });
      },
      { rootMargin: '200px', threshold: 0.25 }
    );
  }

  connectedCallback() {
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  loadIframe() {
    if (!this.template) return;

    const iframe = this.template.content.firstElementChild.cloneNode(true);
    iframe.src = iframe.dataset.src;
    iframe.setAttribute('loading', 'lazy');

    this.appendChild(iframe);
    this.iframeLoaded = true;
  }
}

customElements.define('youtube-video', YouTubeVideo);

(function () {
  function deferShoppableVideos(root) {
    var scope = root || document;
    scope.querySelectorAll('[id*="geowebreelshoping"] video').forEach(function (video) {
      var source = video.getAttribute('data-ashoka-video-src') || video.getAttribute('data-src') || video.getAttribute('src');
      video.removeAttribute('autoplay');
      video.autoplay = false;
      video.setAttribute('preload', 'none');
      if (source) {
        video.setAttribute('data-ashoka-video-src', source);
        video.removeAttribute('data-src');
        video.removeAttribute('src');
        try {
          video.load();
        } catch (error) {}
      }
    });
  }

  function loadActiveShoppableVideo(root) {
    var scope = root || document;
    var video = scope.querySelector('[id*="geowebreelshoping"] [class*="video-modal-"].active .swiper-slide-active video[data-ashoka-video-src]') ||
      scope.querySelector('[id*="geowebreelshoping"] [class*="video-modal-"].active video[data-ashoka-video-src]');

    if (!video) return;

    var source = video.getAttribute('data-ashoka-video-src');
    video.removeAttribute('autoplay');
    video.autoplay = false;
    video.setAttribute('preload', 'metadata');
    if (source && !video.getAttribute('src')) {
      video.setAttribute('src', source);
      video.load();
    }
    video.play().catch(function () {});
  }

  window.AshokaDeferShoppableVideos = window.AshokaDeferShoppableVideos || deferShoppableVideos;
  window.AshokaLoadActiveShoppableVideo = window.AshokaLoadActiveShoppableVideo || loadActiveShoppableVideo;

  deferShoppableVideos(document);

  document.addEventListener('DOMContentLoaded', function () {
    deferShoppableVideos(document);
  }, { capture: true });

  document.addEventListener('shopify:section:load', function (event) {
    deferShoppableVideos(event.target);
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[id*="geowebreelshoping"] [class*="video-top-"], [id*="geowebreelshoping"] [class*="video-modal-prev-"], [id*="geowebreelshoping"] [class*="video-modal-next-"], [id*="geowebreelshoping"] [class*="video-modal-action-"]')) return;
    window.setTimeout(function () {
      loadActiveShoppableVideo(document);
    }, 260);
  }, true);
})();
